module.exports = __webpack_public_path__ + "img/qrcode_qygzh.fb59cd22.jpeg";